<section class="h-100 gradient-custom " style="background-color: #eee;">
  <div class="container py-4 h-100 ">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-12 ">
        <div class="card rounded-4" style="border-radius: 1px;">
          <div class="card-header px-4 py-2 d-flex justify-content-between align-items-center">
            <h5 class="text-muted mb-0">
              Thanks for your Order ,
              <span class="text-danger fw-bold"> {{  customer.firstName }} {{ customer.lastName }}</span>!
            </h5>
            <div *ngFor="let item of pendingOrderItems" class="card shadow-0 border mb-4">
            <button *ngIf="item.status == 'DELIVERY_SUCCESS' || item.status == 'SETTLED'" class="btn btn-danger btn-md-lg btn-sm" (click)="downloadInvoice()">Download Invoice</button>
          </div>
          </div>
          <div class="card-body p-2">
            <!-- Small Screen Layout-->
            <!--<div *ngIf="isSmallScreen" class="small-screen-timeline">
              <p-timeline [value]="events">
                <ng-template pTemplate="opposite" let-event>
                  {{ event.status }}
                </ng-template>
              </p-timeline>
            </div>

            &lt;!&ndash; Normal Screen Layout &ndash;&gt;
            <div *ngIf="!isSmallScreen" class="normal-screen-timeline d-flex flex-column gap-1 gap-md-3 mb-2 ms-md-5">
              <p-timeline [value]="events" layout="horizontal" align="top">
                <ng-template pTemplate="content" let-event>
                  <span class="timeline-text">{{ event.status }}</span>
                </ng-template>
              </p-timeline>
            </div>-->

            <!-- Order Summary -->
            <div class="container-fluid py-2">
              <div class="d-flex flex-wrap justify-content-between ms-md-5">
                <!-- Shipping Address -->
                <div class="flex-column me-3 mb-4 ms-md-5" style="flex: 1; min-width: 250px;">
                  <h6 class="fw-bold mb-3">Shipping Address</h6>
                  <p class="text-muted small mb-0">{{ shippingAddress.name || 'N/A' }}</p>
                  <p class="text-muted small mb-0">{{ shippingAddress.line1 || 'N/A' }}</p>
                  <p class="text-muted small mb-0">{{ shippingAddress.line2 || 'N/A' }}</p>
                  <p class="text-muted small mb-0">
                    {{ shippingAddress.city || 'N/A' }}, {{ shippingAddress.state || 'N/A' }} - {{ shippingAddress.pinCode || 'N/A' }}
                  </p>
                  <p class="text-muted small mb-0">Phone: {{ shippingAddress.phoneNumber || 'N/A' }}</p>
                </div>

                <!-- Store Address -->
                <div class="flex-column mb-4 ms-md-5" style="flex: 1; min-width: 250px;">
                  <h6 class="fw-bold mb-3">Store Address</h6>
                  <p class="text-muted fw-bold small mb-0">SmartDukaan</p>
                  <p class="text-muted small mb-0">{{ storeaddres.name || 'N/A' }}</p>
                  <p class="text-muted small mb-0">{{ storeaddres.line1 || 'N/A' }}</p>
                  <p class="text-muted small mb-0">{{ storeaddres.line2 || 'N/A' }}</p>
                  <p class="text-muted small mb-0">
                    {{ storeaddres.city || 'N/A' }}, {{ storeaddres.state || 'N/A' }} - {{ storeaddres.pinCode || 'N/A' }}
                  </p>
                  <p class="text-muted small mb-0">Phone: {{ storeaddres.phoneNumber || 'N/A' }}</p>
                </div>
              </div>
            </div>

            <!-- Iterate over each order item -->
            <div *ngFor="let item of pendingOrderItems" class="card shadow-0 border rounded-3 mb-4">
              <a role="button" (click)="navigateToProductDetail(item?.catalogId)">
                <div class="card-body">
                  <div class="row">
                    <!-- Product Image -->
                    <div class="col-md-3 d-flex justify-content-center align-items-center">
                      <img [src]="item.imgUrl" class="img-fluid" style="max-height: 100px;" [alt]="item.itemName"/>
                    </div>

                    <!-- Product Name -->
                    <div class="col-md-3 text-center d-flex justify-content-center align-items-center">
                      <p class="text-muted mb-0 fw-bold">{{ item.itemName }}</p>
                    </div>

                    <!-- Product Quantity -->
                    <div class="col-md-3 text-center d-flex justify-content-center align-items-center">
                      <p class="text-muted mb-0 small">Qty: {{ item.quantity }}</p>
                    </div>

                    <!-- Product Price -->
                    <div class="col-md-3 fw-bold text-center d-flex justify-content-center align-items-center">
                      <p class="text-muted mb-0 small">{{ item.sellingPrice | currency: "INR" }}</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card-footer border-0 px-4 py-2 mb-md-0 mb-1" style="background-color: #D3181F; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">

            <!-- Payment Breakdown -->
            <div class="flex-column align-items-end justify-content-end " style="flex: 1; min-width: 250px;">
              <h6 class="fw-bold text-white mb-3">Pay on Delivery</h6>

              <!-- Subtotal -->
              <div class="d-flex justify-content-between text-white">
                <p class="small mb-0">Item(s) Subtotal:</p>
                <p class="small mb-0 text-end">{{ subtotal| currency: "INR" }}</p>
              </div>

              <!-- COD Fee -->
              <div class="d-flex justify-content-between text-white">
                <p class="small mb-0">Delivery Fee:</p>
                <p class="small mb-0 text-end">{{ codFee| currency: "INR" }}</p>
              </div>

              <!-- Total Before Discount -->
              <div class="d-flex justify-content-between text-white">
                <p class="fw-bold small mb-0">Total:</p>
                <p class="fw-bold small mb-0 text-end">{{ subtotal + codFee | currency: "INR" }}</p>
              </div>

              <!-- Promotion Applied -->
              <div class="d-flex justify-content-between text-white">
                <p class="small mb-0">Promotion Applied:</p>
                <p class="small mb-0 text-end">- {{ promotionDiscount| currency: "INR" }}</p>
              </div>

              <!-- Grand Total -->
              <div class="d-flex justify-content-between text-white">
                <p class="fw-bold small mb-0">Grand Total:</p>
                <p class="fw-bold small mb-0 text-end">{{ grandTotal| currency: "INR" }}</p>
              </div>
              <!-- Total Paid -->
              <h5 class="d-flex align-items-center justify-content-end text-white text-uppercase mb-0 mt-3">
                Total paid: <span class="fw-bold h2 mb-0 ms-2">{{ grandTotal| currency: "INR" }}</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
